<template>
    <div class="wrap">
        <div class="calculate">
            <div class="calculate__container">
                <div class="calculate__animation">
                    <vLottiePlayer :animationData="require('./assets/lottie/loading.json')" background="transparent" speed="1" style="width: 100%; height: 100%;" loop autoplay></vLottiePlayer>
                </div>
                <p class="title">결과를 확인중이에요!</p>
            </div>
        </div>
    </div>
</template>

<script>
import VueLottiePlayer from 'vue-lottie-player'

export default {
    name : 'myprotein-calculate',
    components: {
		vLottiePlayer: VueLottiePlayer
	},
    mounted () {
        window.setTimeout(()=> {
            this.$router.push('/myprotein-result')
        },1500)
    }
}
</script>
<style scoped>
@import "./assets/css/amway.css";
</style>



// WEBPACK FOOTER //
// src/views/myprotein-test/calculate.vue